import { _t } from '@/i18n/t';

import SidebarItem from './SidebarItem';
import { isSelectedPath } from './data';
import type { MenuSubgroup } from './types';

type Props = {
  subgroup: MenuSubgroup;
  isCollapsed: boolean;
  pathname: string;
};

const SidebarSubsection = ({ subgroup, isCollapsed, pathname }: Props) => (
  <div className="mt-2.5 first:mt-1">
    {!isCollapsed && (
      <div className="flex h-5 items-center gap-2 px-4 mb-px">
        <subgroup.icon className="h-3.5 w-3.5 flex-shrink-0 text-nav-heading" />
        <span className="text-nav-heading text-sidebar-subheading uppercase">
          {_t(subgroup.labelKey)}
        </span>
      </div>
    )}

    <div className="space-y-0.5">
      {subgroup.items.map((item) => (
        <SidebarItem
          key={item.id}
          item={item}
          isCollapsed={isCollapsed}
          selected={isSelectedPath(pathname, item.relatedPaths)}
        />
      ))}
    </div>
  </div>
);

export default SidebarSubsection;
